
import { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/lib/auth';
import { useToast } from "@/hooks/use-toast";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { user, session } = useAuth();
  const location = useLocation();
  const { toast } = useToast();

  useEffect(() => {
    if (user === null || session === null) {
      console.log('ProtectedRoute - Redirecting to login from:', location.pathname);
      toast({
        title: "Authentication Required",
        description: "You need to be logged in to access this page",
        variant: "destructive"
      });
    }
  }, [user, session, location, toast]);

  // If we're still loading the auth state, show a loading spinner
  if (user === undefined || session === undefined) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  // If there's no user or session, redirect to login with the current path
  if (user === null || session === null) {
    return <Navigate to="/auth/login" state={{ from: location.pathname }} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
